import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import FeedSeparatorsEnabled from "%/dynamic-component-editor/options/feed-separators-enabled";
import FeedSeparatorsComponentId from "%/dynamic-component-editor/options/feed-separators-component-id";
import FeedSeparatorsRules from "%/dynamic-component-editor/options/feed-separators-rules";
import FeedReadPositionEnabled from "%/dynamic-component-editor/options/feed-read-position-enabled";
import FeedReadPositionField from "%/dynamic-component-editor/options/feed-read-position-field";
import FeedReadPositionLabel from "%/dynamic-component-editor/options/feed-read-position-label";
import FeedReadPositionAction from "%/dynamic-component-editor/options/feed-read-position-action";

// Section separators: a header component inserted between rows whenever a rule
// matches. Following feed-empty-state-options, the toolset renders the on/off
// switch and only the settings that apply when it is on, so an author can never
// leave a value that is silently ignored.
export default class FeedSeparatorsOptions extends BaseOptionsBundle {

  optionTitle = "Conditional Separators";
  static optionClassName = "i-feed-separators";
  inspectorToolGroup = "feedSeparators";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.FEED_SEPARATORS_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      new FeedSeparatorsEnabled(),
      new FeedSeparatorsComponentId(),
      new FeedSeparatorsRules(),
      new FeedReadPositionEnabled(),
      new FeedReadPositionField(),
      new FeedReadPositionLabel(),
      new FeedReadPositionAction(),
    ]);
  }
}
